
import { useTranslation } from "react-i18next"
import { ResourceContentSection } from "@/components/molecules/ResourceContentSection/ResourceContentSection"

export function LegalInfoContent() {
  const { t } = useTranslation()

  const contentItems = [
    { type: "heading1" as const, content: t("legal.overview.title") },
    { type: "paragraph" as const, content: t("legal.overview.content") },

    { type: "heading2" as const, content: t("legal.constitutional.title") },
    { type: "paragraph" as const, content: t("legal.constitutional.content") },

    { type: "heading2" as const, content: t("legal.judicial.title") },
    { type: "paragraph" as const, content: t("legal.judicial.content") },

    { type: "heading2" as const, content: t("legal.criminal.title") },
    { type: "paragraph" as const, content: t("legal.criminal.content") },

    { type: "heading2" as const, content: t("legal.civil.title") },
    { type: "paragraph" as const, content: t("legal.civil.content") },

    { type: "heading2" as const, content: t("legal.employment.title") },
    { type: "paragraph" as const, content: t("legal.employment.content") },

    { type: "heading2" as const, content: t("legal.ip.title") },
    { type: "paragraph" as const, content: t("legal.ip.content") },

    { type: "heading2" as const, content: t("legal.immigration.title") },
    { type: "paragraph" as const, content: t("legal.immigration.content") },

    { type: "heading2" as const, content: t("legal.privacy.title") },
    { type: "paragraph" as const, content: t("legal.privacy.content") },

    { type: "heading2" as const, content: t("legal.corruption.title") },
    { type: "paragraph" as const, content: t("legal.corruption.content") },

    { type: "heading2" as const, content: t("legal.consumer.title") },
    { type: "paragraph" as const, content: t("legal.consumer.content") },

    { type: "heading2" as const, content: t("legal.environmental.title") },
    { type: "paragraph" as const, content: t("legal.environmental.content") },

    { type: "heading2" as const, content: t("legal.property.title") },
    { type: "paragraph" as const, content: t("legal.property.content") },

    { type: "heading2" as const, content: t("legal.human.title") },
    { type: "paragraph" as const, content: t("legal.human.content") },

    { type: "heading2" as const, content: t("legal.conclusion.title") },
    { type: "paragraph" as const, content: t("legal.conclusion.content") },
  ]

  return <ResourceContentSection items={contentItems} />
}
